/**
 * @fileoverview POST handler for the "/engagement/link_templates/update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLinkTemplatesUpdateTagsCacheKeys } from "./constants";
import type { PostEngagementLinkTemplatesUpdateTagsProps, EngagementLinkTemplatesUpdateTagsResult } from "./types";

export const postEngagementLinkTemplatesUpdateTags = reactQueryMutationAdapter(
  engagementLinkTemplatesUpdateTagsCacheKeys,
  ({
    undo_identifier,
    desired_state,
  }: PostEngagementLinkTemplatesUpdateTagsProps): Promise<EngagementLinkTemplatesUpdateTagsResult> => {
    return fetch("/engagement/link_templates/update_tags", "POST", {
      undo_identifier,
      desired_state,
    });
  }
);
